import { Stack, Typography } from '@mui/material';

import InfoIcon from '../../../assets/icons/InfoIconBorderFill';
import { TextButton } from '../../../components/styledComponents/Button';
import colors from '../../../constants/colors';
import useAnalytics from '../../../hooks/useAnalytics';

interface AutoPayInfoGraphicProps {
  setOpen: (bool: boolean) => void;
  installmentFee: string;
  policyNumber?: string;
}

const AutoPayInfoGraphic = ({
  setOpen,
  installmentFee,
  policyNumber,
}: AutoPayInfoGraphicProps) => {
  const { track } = useAnalytics();
  return (
    <Stack
      spacing={2}
      direction="row"
      sx={{
        alignItems: "center",
        px: 3,
        py: 1,
        backgroundColor: colors.csaaNeutral,
        borderRadius: 1
      }}>
      <InfoIcon />
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 400,
          lineHeight: '16px',
          fontFamily: 'Cabin',
          fontKerning: 'normal',
        }}
      >
        Save up to {installmentFee} per installment when you enroll in AutoPay
        with a checking or savings account.{' '}
        <TextButton
          sx={{
            color: colors.csaaSpectrumBlue50,
            cursor: 'pointer',
            fontSize: 14,
            fontWeight: 400,
            lineHeight: '16px',
            fontFamily: 'Cabin',
            fontKerning: 'normal',
            backgroundColor: 'inherit',
            verticalAlign: 'inherit',
            '&:hover': {
              backgroundColor: colors.blackInteractiveButtonHover,
            },
          }}
          onClick={() => {
            track('Installment Fees Viewed', {
              location: 'Feature Card',
              link: 'View installment fees',
              event_type: 'Link Accessed',
              policy_number: policyNumber,
            });
            setOpen(true);
          }}
        >
          View installment fees
        </TextButton>
      </Typography>
    </Stack>
  );
};

export default AutoPayInfoGraphic;
